import { IrisBase } from './IrisBase';
import { IrisContainer, IIrisContainerConstParam } from './IrisContainer';

export interface IIrisModContainerConstParam extends IIrisContainerConstParam {
    mod_key:string|null
    result_code:number
    result_msg:string|null
}

export class IrisModContainer<Tiris extends IrisBase> extends IrisContainer<Tiris>  {
            
    public mod_key:string|null
    public result_code:number
    public result_msg:string|null    
    
    constructor({data_type,gli_key,mod_key,result_code,result_msg,data }:IIrisModContainerConstParam, factory:(data:any)=>Tiris) {                        
        super({data_type,gli_key,data },factory)        
        this.mod_key = mod_key
        this.result_code = result_code
        this.result_msg = result_msg        
    }
}
